import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '著作権は大丈夫ですか？',
      answer: 'はい、弊社では、図書館および出版社から正規の手続きで論文を入手しており、著作権法を遵守した適正な文献のみを提供しております。安心してご利用いただけます。'
    },
    {
      question: '料金はいくらですか？',
      answer: 'お見積もりをご確認ください（文献代、著作権料によって異なります）'
    },
    {
      question: 'どのくらいの期間で論文を入手できますか？',
      answer: '最短15分でお届けします。（通常当日にお届け）'
    },
    {
      question: '要約や翻訳のサービスはありますか？',
      answer: 'はい、要約（サマリー）、翻訳作成サービスをご用意しております。お問い合わせください。'
    },
    {
      question: '海外文献の論文も対応していますか？',
      answer: 'はい、国内外の論文に対応しています。'
    },
    {
      question: '論文を複数人で共有したい場合はどうしたらいいでしょうか？',
      answer: '団体利用など、面倒な著作権権利関係のご相談にも応じます。学会の医療ガイドライン作成等、複数人で論文を共有したいが著作権処理についてどのようにすればいいか分からない場合など、お気軽にお問い合わせください。'
    }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            よくある質問
          </h2>
          <p className="text-sm sm:text-base text-gray-600">
            お客様からよくいただくご質問にお答えします
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border-2 border-gray-100 rounded-xl overflow-hidden hover:border-teal-200 transition-all"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-4 sm:px-6 py-4 sm:py-5 flex items-center justify-between gap-3 sm:gap-4 text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-start gap-2 sm:gap-3 flex-1 min-w-0">
                  <div className="w-6 h-6 sm:w-7 sm:h-7 bg-teal-600 text-white rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-xs sm:text-sm font-bold">Q</span>
                  </div>
                  <span className="text-sm sm:text-base md:text-lg font-semibold text-gray-900 leading-relaxed">
                    {faq.question}
                  </span>
                </div>
                <i
                  className={`ri-arrow-down-s-line text-xl sm:text-2xl text-teal-600 transition-transform flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-4 sm:px-6 pb-4 sm:pb-5">
                  <div className="flex items-start gap-2 sm:gap-3 pl-0 sm:pl-10">
                    <div className="w-6 h-6 sm:w-7 sm:h-7 bg-gray-100 text-gray-700 rounded-full flex items-center justify-center flex-shrink-0 sm:hidden">
                      <span className="text-xs sm:text-sm font-bold">A</span>
                    </div>
                    <p className="text-xs sm:text-sm md:text-base text-gray-700 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
